export default __webpack_public_path__ + "static/media/icon-annual-leave-full.5c65fa15.svg";